import { Container, Row } from "reactstrap";
import { Col } from "react-bootstrap";
import { Breadcrumbs } from '../../AbstractElements';
import React, { Fragment } from 'react'
import PayinPayoutHome from "./PayinPayoutHome";

export default function PayinPayout() {
    return (
        <Fragment>
            <Breadcrumbs mainTitle="List of Paid-in Paid-out" parent="Home" title="List of Paid-in Paid-out" />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                       <PayinPayoutHome />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
